import ThemeInfoListSchema from '../schemas/ThemeInfoListSchema'

export default function ThemeInfoListVo(initData = {}) {
  return ThemeInfoListSchema.validateSync(initData)
}
